{
    "Profile_Insured.applicantDetails": "Insured Applicant Details",
    "Profile_Insured.name": "Name",
    "Profile_Insured.communicationDetails": "Insured Contact Details",
    "Profile_Insured.contactDetails": "Contact Details",
    "Profile_Insured.email": "Email",
    "Profile_Insured.phone": "Phone",
    "Profile_Insured.mobile": "Mobile",
    "Profile_Insured.addressDetails": "Insured Risk Address",
    "Profile_Insured.locationDetails": "Location Details",
    "Profile_Insured.mailingAddressDetails": "Insured Mailing Address",
    "Profile_Insured.mailingAddressSameAsAbove": "Mailing Address same as above address",
    "Profile_Insured.warning": "Warning",
    "Profile_Insured.stateChangeWarning": "Coverage limits vary by state. Please reselect a different coverage limit according to the new state.",
    "Profile_Insured.ok": "OK",
    "Profile_Insured.cancel": "Cancel"
}
